import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const fillout = defineConnector({
  identifier: "fillout",
  name: "Fillout",
  tagLine: "Form builder",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: ({ base_url }) => domainToRegex(base_url),
  auth: oauthAuth,
  steps: [
    {
      title: "Enter your Fillout instance details",
      items: [
        {
          kind: "markdown",
          content: "Enter the details for your Fillout instance.",
        },
        {
          kind: "input",
          label: "",
          placeholder: "your-base_url",
          required: true,
          target: { kind: "configuration", field: "base_url" },
        },
      ],
    },
    {
      title: "Create a Fillout app",
      items: [
        {
          kind: "markdown",
          content:
            "Go to the [Fillout Developer Portal](https://www.fillout.com/developers) and create a new OAuth application to get your client ID and client secret.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/fillout/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your Fillout account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Fillout account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://build.fillout.com/authorize/oauth",
    tokenEndpoint: () => "https://server.fillout.com/public/oauth/accessToken",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.fillout.com/v1/api/forms",
  },
  publicEnvVars: ({ base_url }) => ({
    FILLOUT_BASE_URL: base_url || "",
  }),
});
